import {CSSProperties, FC} from 'react';


export interface IIconTestDriveBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTestDriveBmw: FC<IIconTestDriveBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12.756 17.91v-1.56c0-2.21 1.835-3.63 4.044-3.63h1.175c-.228 2.5-2.22 4.74-5.22 5.19Zm-6.73-5.19H7.2c2.21 0 3.556 1.42 3.556 3.63v1.56c-2.5-.45-4.503-2.69-4.73-5.19ZM12 6c2.778 0 5.114 1.9 5.794 4.468C15.327 10.258 14.292 9 12 9s-3.327 1.258-5.794 1.468C6.886 7.9 9.222 6 12 6Zm0-2C7.589 4 4 7.59 4 12s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Z" clipRule="evenodd" />
        </svg>
    );
};
